import React from 'react'
import { Route } from 'react-router-dom'
import { FormsCreate, FormsEdit, FormsMain, FormsView, IndexForms } from '../Views/Web/Forms'

function FormRoutes() {
    return (
      <Route path="forms" element={<FormsMain />}>
           <Route index element={<IndexForms/>} />
           <Route path='create' element={<FormsCreate/>} />
           <Route path='edit/:formsEditId' element={<FormsEdit/>} />
           <Route path='view/:formsViewId' element={<FormsView/>} />
         
          
      </Route>
    )
  }
  
  export default FormRoutes